import styled from "styled-components";


export const ContainerCardSelect = styled.div`
    width: 333px;
    height: 151px;
    margin: auto;
    border-radius: 16px;
    box-shadow: 0px 41.7776px 33.4221px rgba(0, 0, 0, 0.0503198), 0px 22.3363px 17.869px rgba(0, 0, 0, 0.0417275), 0px 12.5216px 10.0172px rgba(0, 0, 0, 0.035), 0px 6.6501px 5.32008px rgba(0, 0, 0, 0.0282725), 0px 2.76726px 2.21381px rgba(0, 0, 0, 0.0196802);

`;

export const TopCardSelect = styled.div`
    width: 100%;
    height: 45px;
    background: var(--color-secondary-gradient);
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    color: var(--color-white); 
    display: flex;
    align-items: center;
    gap: 20px;
    padding-left: 20px;
    span {
        font-weight: 700;
        font-size: 18px;
        line-height: 150%;
    }
`;

export const BodyCardSelect = styled.div`
    height: 106px;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    button{
        width: 140px;
        height: 53px;
        border-radius: 9px;
        background: var(--color-primary);
        font-weight: 500;
        font-size: 18px;
        line-height: 150%;
        color: var(--color-white)
    }
    div {
        width: 50%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        .text {
            font-weight: 400;
            font-size: 16px;
            line-height: 150%;
        }
        .bold {
            font-weight: bold;
        }
    }
`;